import axios from 'axios';

const API_URL = '/api/v1/auth/';

// Register user
const register = async (userData) => {
  const response = await axios.post(API_URL + 'register', userData);

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data));
  }

  return response.data;
};

// Login user
const login = async (userData) => {
  const response = await axios.post(API_URL + 'login', userData);

  console.log('Login response:', response.data); // Debug log

  if (response.data) {
    localStorage.setItem('user', JSON.stringify(response.data));
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
      console.log('Token saved to localStorage:', response.data.token); // Debug log
    } else {
      console.log('No token in response data'); // Debug log
    }
  }

  return response.data;
};

// Logout user
const logout = async () => {
  try {
    await axios.post(API_URL + 'logout');
  } catch (error) {
    console.error('Logout error:', error);
  }
  localStorage.removeItem('user');
};

// Update user profile
const updateProfile = async (userData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const response = await axios.put(API_URL + 'updatedetails', userData, config);

  if (response.data && response.data.success) {
    // Update the stored user data with the new information
    const storedUser = JSON.parse(localStorage.getItem('user'));
    const updatedUser = { ...storedUser, ...response.data.data };
    localStorage.setItem('user', JSON.stringify(updatedUser));
    return updatedUser;
  }

  return response.data;
};

const authService = {
  register,
  login,
  logout,
  updateProfile,
};

export default authService;